import React, { useRef } from "react";
import html2pdf from "html2pdf.js";
import { FaTimes, FaDownload } from "react-icons/fa";

const InvoiceModal = ({ isOpen, closeModal, order }) => {
  const invoiceRef = useRef(null);

  const downloadPDF = () => {
    const opt = {
      margin: 0.3,
      filename: `${order?.orderId}_invoice.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(invoiceRef.current).set(opt).save();
  };

  if (!isOpen) return <>  1231 </>;

  return (
    <div className=" inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold">Invoice #{order?.orderId}</h2>
          <button
            onClick={closeModal}
            className="text-gray-600 hover:text-red-600"
          >
            <FaTimes size={18} />
          </button>
        </div>

        {/* Invoice Body */}
        <div ref={invoiceRef} className="p-6 text-sm space-y-3">
          <div className="flex justify-between">
            <div>
              <h3 className="font-bold text-gray-800">{order?.userId?.name}</h3>
              <p>{order?.userId?.mobile}</p>
            </div>
            <div className="text-right">
              <p className="font-semibold text-gray-600">Order Date</p>
              <p>{new Date(order.createdAt).toLocaleString()}</p>
            </div>
          </div>

          <hr className="my-3" />

          {/* PRODUCT TABLE */}
          <table className="w-full border text-xs">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 text-left">Product</th>
                <th className="p-2 text-right">Qty</th>
                <th className="p-2 text-right">Price</th>
                <th className="p-2 text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {order?.products?.map((item, i) => {
                const p = item.productId;
                return (
                  <tr key={i} className="border-t">
                    <td className="p-2">{p?.name}</td>
                    <td className="p-2 text-right">{item.quantity}</td>
                    <td className="p-2 text-right">₹{item.priceAtPurchase}</td>
                    <td className="p-2 text-right">
                      ₹{item.priceAtPurchase * item.quantity}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="flex justify-end mt-3">
            <p className="font-bold text-gray-800">
              Grand Total: ₹{order.totalAmount}
            </p>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t flex justify-between">
          <button
            onClick={closeModal}
            className="px-4 py-2 text-sm border rounded hover:bg-gray-50"
          >
            Close
          </button>
          <button
            onClick={downloadPDF}
            className="px-4 py-2 text-sm bg-orange-600 text-white rounded flex items-center gap-2 hover:bg-orange-700"
          >
            <FaDownload /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceModal;
